import { useEffect, useRef, useState } from 'react'
import { Input } from '@progress/kendo-react-inputs'
import { Label,Error } from '@progress/kendo-react-labels'
import parse from 'html-react-parser'
import { useGlobalCtx } from '../../../Context/GlobalContext'
import { SurveyEngine_Models_AuthenticateUserResponse, SurveyEngine_Models_BaseResponse } from '../../../api'

interface AuthenticateProps {
  id:number,
  message: string,
  errorMesage:string, 
  isError: boolean,
  userNameCaption: string
  userValue:string,
  passwordCaption: string,
  passValue:string,
  focus:boolean
  callback: (response: SurveyEngine_Models_BaseResponse) => void
}

export const Authenticate = (props:AuthenticateProps) => {

  const [user,setUser] = useState<string>(props.userValue);
  const [isError,setIsError] = useState(props.isError);
  const [pass,setPass] = useState<string>(props.passValue);
  const [userTouched,setUserTouched] = useState(false);
  const [passTouched,setPassTouched] = useState(false);
  const UserlabelId = `${props.id}_Userlabel`
  const UserInputId = `${props.id}_UserInput`
  const UserErrorId = `${props.id}_UserError`

  const PasslabelId = `${props.id}_Passlabel`
  const PassInputId = `${props.id}_PassInput`
  const PassErrorId = `${props.id}_PassError`

  const MsglabelId = `${props.id}_Msglabel`
  
  const globalCTX = useGlobalCtx()

  const authUserRef = useRef<Input>(null);
  const authPassRef = useRef<Input>(null);
  
  function HintOrError() {
    if(!pass && passTouched)
        return <Error id={PassErrorId} direction='end'>{globalCTX.LangResources.authenticateMsg.passNoValue.replace('{Password}',props.passwordCaption)}</Error>
    else if(isError){
        return <Error id={PassErrorId} direction='end'>{parse(props.errorMesage.replace(/""/g,'"'))}</Error>
    }
    else
        return <></>
  }  

  useEffect(() => {
    if(!user)
        authUserRef.current?.focus();
    else if(props.isError){
        authPassRef.current?.focus();
    }
   }, [props])

  const HandleUserChange = (e:string) =>{
    let response: SurveyEngine_Models_AuthenticateUserResponse = {
        commandType: "Remove",
        commandIndex: props.id,
        username:"",
        password:""
    };
    if(e && pass)
    {
        response={
            commandType: "AuthenticateUser",
            commandIndex: props.id,
            username:user,
            password:e
          };
    }
    props.callback(response);
    setUser(e);
  }
  const HandlePassChange = (e:string) =>{
    let response: SurveyEngine_Models_AuthenticateUserResponse = {
        commandType: "Remove",
        commandIndex: props.id,
        username:"",
        password:""
    };   
    if(e && user)
    {
         response = {
            commandType: "AuthenticateUser",
            commandIndex: props.id,
            username:user,
            password:e
          };
    }
    try {
       props.callback(response);
       setPass(e);
       setIsError(false); 
    } catch (error) {
       setIsError(true)
    }
  }
return (
<div className="theme-question mb-3 w-full">
    <Label
        className="text-xl font-semibold"
        id={MsglabelId}
    >
        {parse(props.message.replace(/""/g,'"'))}
    </Label>
    <div>
    <Label
        className="text-lg font-normal"
        id={UserlabelId}
    >
        {parse(props.userNameCaption.replace(/""/g,'"'))}
    </Label>
    <Input
        ref={authUserRef}
        type="text"
        id={UserInputId}
        aria-labelledby={`${MsglabelId} ${UserlabelId}`}
        aria-describedby={UserErrorId}
        value={user}
        maxLength={50}
        ariaDescribedBy={UserErrorId}
        onChange={(e) => HandleUserChange(e.value?.toString())}
        onBlur={()=>setUserTouched(true)}
    />
    {!user && userTouched && <Error id={UserErrorId} direction='end'>{globalCTX.LangResources.authenticateMsg.userNoValue.replace('{Username}',props.userNameCaption)}</Error>}
    </div>
    <Label
        className="text-lg font-normal"
        id={PasslabelId}
        editorId={PassInputId}
    >
        {parse(props.passwordCaption.replace(/""/g,'"'))}
    </Label>
    <Input
        ref={authPassRef}
        type="Password"
        id={PassInputId}
        value={pass}
        maxLength={50}
        ariaDescribedBy={PassErrorId}
        onChange={(e) => HandlePassChange(e.value?.toString())}
        onFocus={()=>setPassTouched(true)}
    />
    {<HintOrError/>}

    </div>);
}
export default Authenticate

